import PropTypes from "prop-types";

const HeartFilledIcon = ({ width = 24, height = 24, fill = "#FF2600" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_bd_7084_258)">
      <path
        d="M12.0009 5.27598C14.115 3.37788 17.382 3.44088 19.4187 5.48118C21.4545 7.52238 21.5247 10.7732 19.6311 12.8936L11.9991 20.5364L4.36891 12.8936C2.47531 10.7732 2.54641 7.51698 4.58131 5.48118C6.61981 3.44358 9.88051 3.37518 12.0009 5.27598Z"
        fill={fill}
      />
    </g>
    <defs>
      <filter
        id="filter0_bd_7084_258"
        x="-27"
        y="-26.1001"
        width="78.0004"
        height="76.6365"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="15" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_7084_258"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_backgroundBlur_7084_258"
          result="effect2_dropShadow_7084_258"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_7084_258"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

HeartFilledIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string
};

export default HeartFilledIcon;
